<ckeditor *ngIf="ckEditor"
          [editor]="ckEditor"
          [(ngModel)]="value"
></ckeditor>
